import { Box, Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';

function throwTestError(): never {
  throw new Error('Test error for sourcemap verification');
}

function TestErrorPage() {
  const [asyncError, setAsyncError] = useState<Error | null>(null);

  if (asyncError) {
    throw asyncError;
  }

  function handleSyncError() {
    throwTestError();
  }

  function handleAsyncError() {
    setTimeout(() => {
      try {
        throwTestError();
      } catch (e) {
        setAsyncError(e as Error);
      }
    }, 100);
  }

  async function handleFetchError() {
    // This will fail and should show in Datadog
    await fetch('https://api.invalid-domain-that-does-not-exist.com/test');
  }

  function handleUncaughtPromise() {
    // Uncaught promise rejection
    Promise.reject(new Error('Uncaught promise rejection for sourcemap test'));
  }

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Sourcemap Test Page
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Use these buttons to trigger errors and verify sourcemap linking in
        Datadog.
      </Typography>
      <Stack spacing={2} direction="column" sx={{ maxWidth: 400 }}>
        <Button variant="contained" color="error" onClick={handleSyncError}>
          Throw Sync Error
        </Button>
        <Button variant="contained" color="warning" onClick={handleAsyncError}>
          Throw Async Error (re-render)
        </Button>
        <Button variant="contained" color="info" onClick={handleFetchError}>
          Trigger Failed Fetch
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={handleUncaughtPromise}
        >
          Uncaught Promise Rejection
        </Button>
      </Stack>
    </Box>
  );
}

export default TestErrorPage;
